import PrimaryButton from '../../../components/atoms/Button';
import { PlatformOS } from '../../../redux/slices/profile.slice';
import STORAGE_KEYS from '../../../shared/constants/storage';
import { useStorage } from '../../../shared/utils/general.util';

const ButtonNewInvoice = ({
	handleNewInvoice,
}: {
	handleNewInvoice: () => void;
}) => {
	const isFromIOS =
		useStorage().getItem(STORAGE_KEYS.PLATFORM_OS) === PlatformOS.IOS;
	return (
		<div
			className={`z-2 fixed sm:relative sm:bottom-auto left-0 bg-white sm:bg-transparent p-3 sm:p-0 w-full sm:w-fit ${isFromIOS ? 'bottom-[86px]' : 'bottom-12'} `}
		>
			<PrimaryButton
				onClick={handleNewInvoice}
				label='Emitir nueva factura'
				sx='!w-full sm:!w-fit'
			/>
		</div>
	);
};

export default ButtonNewInvoice;
